import styled, { css } from 'styled-components';


export const Root = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    padding: 28px 0 0px;
  `}
`;

export const BrandByMonarxWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.v3.spacing.xxxs};
    position: relative;
  `}
`;

export const Headline = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.brand.snappyBlue[40]};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    text-align: center;
    width: 100%;
    font-size: 20px;
    margin-bottom: 16px;
    
    @media (max-width: ${theme.v3.breakpoints.sm}) {
      max-width: 305px;
    }
  `}
`;

export const FeaturesBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xs};
    width: 100%;
    max-width: unset;
    align-items: stretch;
    margin-bottom: ${theme.v3.spacing.xs};
  `}
`;

export const PrimaryButtonWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  padding: 0;
  width: 100%;
`;
